import {
	Checkbox,
	FormControlLabel,
	IconButton,
	InputAdornment,
	Box
} from "@material-ui/core";
import { VisibilityOffOutlined, VisibilityOutlined } from "@material-ui/icons";
import clsx from "clsx";
import { Formik } from "formik";
import queryString from "querystring";
import React, { useEffect, useState } from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import iconChecked from "../../assets/icons/icon-checked.svg";
import iconNotChecked from "../../assets/icons/icon-not-checked.svg";
import { login } from "../../crud/auth.crud";
import * as auth from "../../store/ducks/auth.duck";
import * as resetPassword from "../../store/resetPassword";
import Loading from "../home/components/Loading";
import { StyledTextField } from "./Components/TextField/style";
import { MutantApiService } from "../../services/MutantApiService";
import { sleep } from "../admin/pages/Prompts/PromptsListing";
import { mutantColors } from "../../assets/styles/themes/default";
// import { ReactComponent as LogoMutant } from "../../../app/assets/logos/logo-mutant.svg";
import { LogoMutant } from "../../assets/logos/logo-mutant";

function Login(props) {
	const { intl, history } = props;
	const [passwordVisibility, setPasswordVisibility] = useState(false);
	const [isLoading, setIsLoading] = useState(true);
	const [loading, setLoading] = useState(true);
	// eslint-disable-next-line no-unused-vars
	const [error, setError] = useState(null);
	const [loadingButtonStyle, setLoadingButtonStyle] = useState({
		paddingRight: "2.5rem"
	});

	const api = new MutantApiService();

	const checkProfile = async () => {
		try {
			const user = await api.makeHttpRequest({
				url: "user/me",
				method: "GET"
			});

			if (!!user) {
				await props.login({ isLogin: true }, user);
				await sleep(3);
				history.push("/dashboard/projects");
			}
		} catch (e) {
			localStorage.clear();
			//reload
			window.location.reload();
		} finally {
			disableLoading();
		}
	};

	useEffect(() => {
		(async () => {
			await checkProfile();

			const searchParams = new URLSearchParams(props.location.search);

			if (!!searchParams.get("access") && !!searchParams.get("refresh")) {
				await props.login(
					{
						accessToken: searchParams.get("access"),
						refreshToken: searchParams.get("refresh"),
						isLogin: true,
						rememberMe: true
					},
					null
				);

				await checkProfile();
			}
		})();

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const enableLoading = () => {
		setLoading(true);
		setIsLoading(true);
		setLoadingButtonStyle({ paddingRight: "3.5rem" });
	};

	const disableLoading = () => {
		setLoading(false);
		setIsLoading(false);
		setLoadingButtonStyle({ paddingRight: "2.5rem" });
	};

	const isLoginExpired = () => {
		const query = queryString.parse(window.location.search.replace("?", ""));
		return query && query.hasOwnProperty("expired");
	};

	const handleClickShowPassword = () => {
		setPasswordVisibility(!passwordVisibility);
	};

	const handleMouseDownPassword = event => {
		event.preventDefault();
	};

	window.setPageTitle("Login");

	const firstTimeLogin = values => {
		props.resetPassword(values);
		history.push("/cadastrar-senha?t=0");
	};

	return (
		<>
			<Loading isLoading={isLoading} />
			<div style={{ backgroundColor: "#F5F0F8", height: "100%" }}>
				<div className="kt-login__body">
					<div className="kt-login__form">
						<div className="kt-login__title">
							<h3
								style={{
									fontSize: "2rem",
									fontWeight: "bold",
									textAlign: "center",
									color: mutantColors.d_blue_4
								}}
							>
								Blackbolt Login
							</h3>
						</div>
						<Formik
							initialValues={{
								email: "",
								password: "",
								rememberMe: false
							}}
							validate={values => {
								const errors = {};

								if (!values.email) {
									// https://github.com/formatjs/react-intl/blob/master/docs/API.md#injection-api
									errors.email = intl.formatMessage({
										id: "AUTH.VALIDATION.REQUIRED_FIELD"
									});
								} else if (
									!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
								) {
									errors.email = intl.formatMessage({
										id: "AUTH.VALIDATION.INVALID_FIELD"
									});
								}

								if (!values.password) {
									errors.password = intl.formatMessage({
										id: "AUTH.VALIDATION.REQUIRED_FIELD"
									});
								}

								return errors;
							}}
							onSubmit={(values, { setStatus, setSubmitting }) => {
								enableLoading();
								login(values.email, values.password)
									.then(data => {
										const { user, ...authData } = data;
										authData.isLogin = true;
										authData.rememberMe = values.rememberMe;
										disableLoading();
										props.login(authData, user);
										history.push("/dashboard/projects");
									})
									.catch(e => {
										disableLoading();
										setSubmitting(false);
										setStatus(
											e.response && e.response.data && e.response.data
												? e.response.data.message
												: intl.formatMessage({
														id: "AUTH.VALIDATION.INVALID_LOGIN"
												  })
										);
									});
							}}
						>
							{({
								values,
								status,
								errors,
								touched,
								handleChange,
								handleBlur,
								handleSubmit,
								isSubmitting
							}) => (
								<>
									<form
										noValidate={true}
										autoComplete="off"
										className="kt-form"
										onSubmit={handleSubmit}
									>
										{(status || isLoginExpired()) && (
											<div role="alert" className="alert alert-danger">
												<div className="alert-text">
													{status ||
														"Sua sessão expirou, faça login para continuar"}
													{status === "É preciso criar uma nova senha" &&
														firstTimeLogin(values)}
												</div>
											</div>
										)}

										{error && (
											<div role="alert" className="alert alert-danger">
												<div className="alert-text">{error}</div>
											</div>
										)}

										<div className="form-group">
											<StyledTextField
												variant="outlined"
												type="email"
												label="E-mail"
												margin="normal"
												className="kt-width-full"
												name="email"
												onBlur={handleBlur}
												onChange={handleChange}
												value={values.email}
												helperText={touched.email && errors.email}
												error={Boolean(touched.email && errors.email)}
											/>
										</div>

										<div className="form-group">
											<StyledTextField
												variant="outlined"
												type={passwordVisibility ? "text" : "password"}
												margin="normal"
												label="Senha"
												className="kt-width-full"
												name="password"
												onBlur={handleBlur}
												onChange={handleChange}
												value={values.password}
												helperText={touched.password && errors.password}
												error={Boolean(touched.password && errors.password)}
												InputProps={{
													endAdornment: (
														<InputAdornment position="end">
															<IconButton
																aria-label="Alterar visibilidade da senha"
																onClick={handleClickShowPassword}
																onMouseDown={handleMouseDownPassword}
																edge="end"
															>
																{passwordVisibility ? (
																	<VisibilityOffOutlined />
																) : (
																	<VisibilityOutlined />
																)}
															</IconButton>
														</InputAdornment>
													)
												}}
											/>
										</div>

										<div className="form-plus">
											<FormControlLabel
												className="remind-me"
												control={
													<Checkbox
														name="rememberMe"
														value={values.rememberMe}
														onChange={handleChange}
														icon={
															<img src={iconNotChecked} alt="Não selecionado" />
														}
														checkedIcon={
															<img src={iconChecked} alt="Selecionado" />
														}
													/>
												}
												label="Lembrar-me"
											/>
										</div>

										<div className="kt-login__actions mb-0 pb-0"
											style={{
												display: "flex",
												justifyContent: "center",
												alignItems: "center"
											}}
										>
											<button
												id="kt_login_signin_submit"
												type="submit"
												disabled={isSubmitting}
												className={`btn btn-elevate kt-login__btn-primary ${clsx(
													{
														"kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": loading
													}
												)}`}
												style={{
													...loadingButtonStyle,
													width: "120px",
													textAlign: "center",
													display: "flex",
													justifyContent: "center",
													alignItems: "center",
													borderRadius: "6px",
												}}
											>
												Entrar
											</button>
										</div>

										<div className="my-3 border-bottom border-secondary" />

										<div className="kt-login__actions"
											style={{
												display: "flex",
												justifyContent: "center",
												alignItems: "center",
											}}
										>
											<a
												id="kt_login_signin_submit"
												className={`btn btn-elevate kt-login__btn-primary kt-login__btn-google d-flex justify-content-center`}
												href={`${process.env.REACT_APP_API_HOST}/api/auth/accounts/google/login/`}
												style={{
													width: "120px"
												}}
											>
												@Mutant
											</a>
										</div>
									</form>
								</>
							)}
						</Formik>
						<Box
						style={{
							marginTop: "200px",
							paddingLeft: "2rem",
						}}
						>
							<LogoMutant
								width={500}
								style={{
									display: "flex",
									justifyContent: "center",
									alignItems: "center"
								}}
							/>
						</Box>
					</div>
				</div>
			</div>
		</>
	);
}

const mapActionsToProps = dispatch =>
	bindActionCreators(
		{
			login: auth.actions.login,
			resetPassword: resetPassword.resetPasswordActions.setCredentials
		},
		dispatch
	);

export default injectIntl(connect(null, mapActionsToProps)(Login));
